// import * as moment from 'moment';
import * as React from 'react';
import { RouteComponentProps } from 'react-router';

// Models
import {
  ContractDetailsViewModel,
  SimpleEntityViewModel,
  ContractResaleModalViewModel,
  Origin
} from '@models/Contract';
import { CustomerViewModel } from '@models/Customer';
import { RealEstateAgentViewModel } from '@models/RealEstateAgent';
import { RealEstateOfficeViewModel } from '@models/RealEstateOffice';
import { EscrowOfficerViewModel } from '@models/EscrowOfficer';
import { EscrowOfficeViewModel } from '@models/EscrowOffice';
import { AddressViewModel, OptionsViewModel } from '@models/common.models';
import { CommentViewModel } from '@models/Comment';
import { CommentType } from '@models/Comment';
import { StatesViewModel } from '@models/common.models';
import { DocumentViewModel, FileViewModel } from '@models/Document';
import { PropertyManagerSearchViewModel } from '@models/PropertyManager';
import { Role, Roles } from '@models/Roles';

// Components
import { CommentSearch } from '../../../comments';
import { Dialog, Tabs, Tab, CheckboxInline } from '@common/components';
import { ModalProps, ToastComponent, ToastType, ToastOptions, SpinnerPage } from '@common/components';
import { getRoute, RouteDefinitions } from '@common/route-definitions';
import { FileList } from '@common/components';
import { ContractInfoComponent } from '../contract-info/contract-info.component';
import { ExtendCOEModalComponent } from '../extend-coe/extend-coe.component';
import { RenewalChoiceComponent } from '../../../renewal/_components/renewal-choice.component';
import { history } from '../../..';
import { toast } from 'react-toastify';
import { dateParser } from '@common/dateParser';
import { Activation } from '../activation';
import { ServiceWorkOrderSearch } from '../../../service-work-order/_components/service-work-order-search/service-work-order-search.container';
import { ContractHistory } from '../contract-history/contract-history.container';
import { ExtendSellersModalComponent } from '../extend-sellers/extend-sellers.component';
import { ContractResale } from '../contract-resale/contract-resale.container';
import { DocumentHistoryTable } from 'src/document-history';
import * as moment from 'moment';
import { ContractResaleModalComponent } from '../contract-resale/contract-resale-modal.component';
import { EditableFields, EditPermissions } from '@models/EditPermissions';
import { RelatedContracts } from '../related-contracts/related-contracts.container';
export interface ContractDetailsProperties extends RouteComponentProps<{ id: number }> {
  readonly contractDetailsVM: ContractDetailsViewModel;
  readonly commentsQuery: string | null;
  readonly commentsLoading: boolean;
  readonly commentsPageCount: number;
  readonly commentsPageNumber: number;
  readonly commentsPageSize: number;
  readonly commentsResults: CommentViewModel[];
  readonly documents: DocumentViewModel[];
  readonly selectedCommentText: string;
  readonly contractResaleModalVM: ContractResaleModalViewModel;
  readonly isOpenContract: boolean;
  readonly isSavingUSPS: boolean;
  readonly shouldClear: boolean;

  readonly uploadFiles: (contractId: number, fileVMs: FileViewModel[]) => void;
  readonly cancelContractOrder: (contractId: number, cancelDate: string) => void;
  readonly clearResaleData: () => void;
  readonly getCommentsByContract: (
    contractId: number,
    pageNumber: number,
    pageSize: number,
    query: string | null,
    filterBy?: string
  ) => void;
  readonly getContractDetails: (id: number) => void;
  readonly getContractResaleData: (id: number) => void;
  readonly getRenewalContract: (contractId: number) => void;
  readonly getServiceWorkOrderContract: (contractId: number) => void;
  readonly loadContractInfoForResale: (id: number, premium: number, resaleDate: Date) => void;
  readonly onBuyerCustomerSelect: (model: string, value: number) => void;
  readonly onSellerCustomerSelect: (model: string, value: number) => void;
  readonly removeFile: (contractId: number, fileId: number) => void;
  readonly selectComment: (commentText: string) => void;
  readonly sendRenewalNotice: (contractId: number) => void;
  readonly toggleModal: (modalProps?: ModalProps) => void;
  readonly updateContract: (id: number, date: Date) => void;
  readonly updateSellers: (id: number, date: Date) => void;
  readonly suspendContract: (id: number) => void;
  readonly resumeContract: (id: number) => void;
  readonly verify: (id: number) => void;
  readonly loadOrderEditContract: (id: number) => Promise<any>;
  readonly clearContractDetails: () => void;
  readonly checkResale: (id: number, date: Date) => Promise<any>;
  readonly updateCoe: (id: number, date: Date) => void;
  readonly setUSPSStatus: (contractId: number, uspsStatus: number) => void;
  readonly setShouldClear: (shouldClear: boolean) => void;
}

export interface ContractDetailsState {
  readonly USPSStatus: boolean;
}

export class ContractDetailsComponent extends React.Component<ContractDetailsProperties, ContractDetailsState> {
  private currentDate: Date;

  constructor(props: ContractDetailsProperties) {
    super(props);
    this.state = {
      USPSStatus: false // this.props.contractDetailsVM.mailReturned > 0
    };

    this.onUploadClick = this.onUploadClick.bind(this);
    this.onRemoveClick = this.onRemoveClick.bind(this);
    this.redirectForResale = this.redirectForResale.bind(this);
    this.renderResaleModal = this.renderResaleModal.bind(this);
    this.sendRenewalNotice = this.sendRenewalNotice.bind(this);
    this.handleTerminateContractOrder = this.handleTerminateContractOrder.bind(this);
    this.redirectForCancel = this.redirectForCancel.bind(this);
    this.redirectForTransfer = this.redirectForTransfer.bind(this);
    this.redirectForSWOCreation = this.redirectForSWOCreation.bind(this);
    this.redirectForNoRenew = this.redirectForNoRenew.bind(this);
    this.suspendContract = this.suspendContract.bind(this);
    this.resumeContract = this.resumeContract.bind(this);
    this.verify = this.verify.bind(this);
  }

  componentDidMount() {
    this.props.setShouldClear(true);
    if (this.props.match && this.props.match.params.id) {
      this.props.getContractDetails(this.props.match.params.id);
      this.props.getContractResaleData(this.props.match.params.id);
    }
    this.currentDate = dateParser.now().toDate();
  }

  componentWillReceiveProps(nextProps: ContractDetailsProperties) {
    if (
      nextProps.contractDetailsVM &&
      nextProps.contractDetailsVM !== this.props.contractDetailsVM &&
      !!nextProps.contractDetailsVM.mailReturned
    ) {
      this.setState({
        USPSStatus: nextProps.contractDetailsVM.mailReturned > 0
      });
    }
  }

  componentWillUnmount() {
    if (this.props.shouldClear) {
      this.props.clearResaleData();
      this.props.clearContractDetails();
    } else {
      this.props.setShouldClear(true);
    }
  }

  sendRenewalNotice = () => {
    if (
      this.props.contractDetailsVM.buyer!.emailAddress &&
      this.props.contractDetailsVM.buyer!.emailAddress.indexOf('@') > 0
    ) {
      this.props.sendRenewalNotice(this.props.contractDetailsVM.id);
    } else {
      toast.error(
        <ToastComponent type={ToastType.Error} message={'Please enter email address for buyer.'} />,
        ToastOptions.Error
      );
    }
  };

  suspendContract = () => {
    this.props.suspendContract(this.props.contractDetailsVM.id);
  };

  resumeContract = () => {
    this.props.resumeContract(this.props.contractDetailsVM.id);
  };

  verify = () => {
    this.props.verify(this.props.contractDetailsVM.id);
  };

  openRenewalModal = () => {
    this.props.toggleModal({
      title: 'Renewal',
      closeLabel: 'Cancel',
      component: RenewalChoiceComponent,
      hideSave: true,
      saveCallback: this.handleRenewal,
      isSmall: true,
      childProps: {
        pastDueServiceFeeTotal: this.props.contractDetailsVM.pastDueServiceFeeTotal,
        contractId: this.props.contractDetailsVM.id
      }
    });
  };

  handleRenewal = (redirectURL: string) => {
    this.props.getRenewalContract(this.props.contractDetailsVM.id);
    this.props.toggleModal();
    this.props.history.push(redirectURL);
  };

  onUploadClick(fileVMs: FileViewModel[]) {
    this.props.uploadFiles(this.props.contractDetailsVM.id, fileVMs);
  }

  onRemoveClick(fileId: number) {
    this.props.removeFile(this.props.contractDetailsVM.id, fileId);
  }

  redirectForResale = async () => {
    if (this.props.loadContractInfoForResale) {
      const id = this.props.contractDetailsVM.id;
      this.props.loadContractInfoForResale(
        id,
        Number.parseFloat(this.props.contractResaleModalVM.credit.substring(1)),
        this.props.contractResaleModalVM.contractResaleDate
      );
      history.push({
        pathname: RouteDefinitions.contract.Create,
        state: { id: id }
      });
      return;
    }
  };

  async handleTerminateContractOrder(date: string) {
    this.props.toggleModal();
    this.props.cancelContractOrder(this.props.contractDetailsVM.id, date);
  }

  openExtendCOEModal = () => {
    this.props.toggleModal({
      title: 'Update COE',
      closeLabel: 'Cancel',
      saveLabel: 'Confirm Extension of COE',
      component: ExtendCOEModalComponent,
      saveCallback: this.handleCOEExtension
    });
  };

  openExtendSellersModal = () => {
    this.props.toggleModal({
      title: 'Extend Sellers Coverage',
      closeLabel: 'Cancel',
      saveLabel: 'Confirm Extension of Sellers Coverage',
      component: ExtendSellersModalComponent,
      saveCallback: this.handleSellersExtension
    });
  };

  openActivateModal = () => {
    this.props.toggleModal({
      childProps: {
        contractId: this.props.contractDetailsVM.id,
        termStartDate: this.props.contractDetailsVM.termStart!
      },
      closeLabel: 'Cancel',
      component: Activation,
      saveCallback: this.props.toggleModal,
      saveLabel: 'Activate',
      title: 'Activate Contract'
    });
  };

  handleCOEExtension = (date: Date) => {
    this.props.toggleModal();
    this.handleResaleCalculation(date, this.props.contractDetailsVM);
  };

  handleResaleCalculation = (date: Date, contract: ContractDetailsViewModel) => {
    const newDate = moment.isMoment(date) ? date.toDate() : date;
    if (contract.propertySaleType.id === 7) {
      this.props
        .checkResale(contract.id, newDate)
        .then(() => {
          if (this.props.contractResaleModalVM) {
            this.props.toggleModal({
              childProps: {
                oldContractNumber: this.props.contractResaleModalVM.contractNumber,
                newContractNumber: contract.contractNumber,
                credit: this.props.contractResaleModalVM.credit
              },
              closeCallback: this.props.toggleModal,
              closeLabel: 'Close',
              hideSave: true,
              component: ContractResaleModalComponent,
              title: 'Resale Calculation'
            });
          }
        })
        .then(() => {
          this.props.updateCoe(this.props.contractDetailsVM.id, date);
        });
    } else {
      this.props.updateCoe(this.props.contractDetailsVM.id, date);
    }
  };

  handleSellersExtension = (date: Date) => {
    this.props.updateSellers(this.props.contractDetailsVM.id, date);
  };

  renderDialog() {
    if (!this.props.selectedCommentText) {
      return;
    }

    return (
      <Dialog
        text={this.props.selectedCommentText}
        textYes="Close"
        onYesClick={() => {
          this.props.selectComment('');
        }}
      />
    );
  }

  renderResaleModal() {
    const redirect = () => {
      this.redirectForResale();
      this.props.toggleModal();
    };
    if (this.props.toggleModal) {
      this.props.toggleModal({
        title: 'Resell Contract?',
        closeLabel: 'Cancel',
        saveLabel: 'Continue',
        saveCallback: redirect,
        component: ContractResale,
        childProps: { isModal: true }
      });
      return;
    }
  }

  redirectForCancel() {
    this.props.setShouldClear(false);
    history.push(getRoute(RouteDefinitions.contract.Cancellation, { id: +this.props.contractDetailsVM.id }));
  }

  redirectForTransfer() {
    history.push(getRoute(RouteDefinitions.contract.Transfer, { id: +this.props.contractDetailsVM.id }));
  }

  redirectForSWOCreation() {
    this.props.getServiceWorkOrderContract(+this.props.contractDetailsVM.id);
    this.props.setShouldClear(false);
    history.push(getRoute(RouteDefinitions.contract.Swo, { id: +this.props.contractDetailsVM.id }));
  }

  redirectForNoRenew() {
    history.push(getRoute(RouteDefinitions.contract.NoRenew, { id: +this.props.contractDetailsVM.id }));
  }

  redirectForOrderEdit = () => {
    history.push(getRoute(RouteDefinitions.contract.OrderEdit, { id: +this.props.contractDetailsVM.id }));
  };

  redirectForMakeAPayment = () => {
    this.props.setShouldClear(false);
    history.push(getRoute(RouteDefinitions.contract.Balances, { id: +this.props.contractDetailsVM.id }));
  };

  renderOrigin = () => {
    if (this.props.contractDetailsVM.origin === Origin.WISE) {
      return <strong>WISE</strong>;
    } else if (this.props.contractDetailsVM.origin === Origin.Web) {
      return <strong>Website</strong>;
    } else {
      return <strong>--</strong>;
    }
  };

  render() {
    let details = this.props.contractDetailsVM;
    if (!details) {
      return <SpinnerPage />;
    }
    let contactType = { id: 0, value: details.contactType };
    let contactMedium = { id: 0, value: details.contactMedium };
    let contactInit = { id: 0, value: details.contactInit };
    let product = {
      id: details.productId,
      value: details.productName,
      productDesc: (details.product || {}).productDesc || '',
      productGroupId: (details.product || {}).productGroupId || ({} as number),
      productChannelId: (details.product || {}).productChannelId || ({} as number)
    };
    let coverageOptions = details.coverageOptions || [];
    let productGroup = { id: details.productGroupId, value: details.productGroupName };
    let priceAdjustment = {
      id: details.priceAdjustment && details.priceAdjustment!.id ? details.priceAdjustment!.id : 0,
      value: details.priceAdjustment && details.priceAdjustment!.value ? details.priceAdjustment!.value : ' ',
      increase: details.priceAdjustment ? details.priceAdjustment.increase : false,
      adjustmentAmount: details.coverageOptions
        ? details.coverageOptions.map(co => co.perDiemPrice).reduce((sum, current) => sum + current)
        : 0,
      percentageAmount: 0
    };
    let totalPrice = details.ctcPriceAmount ? details.ctcPriceAmount : 0;
    let originalPrice = details.originalPrice ? details.originalPrice : 0;
    let propertyAddress = (details.propertyAddress
      ? {
          id: 0,
          line1: details.propertyAddress!.line1,
          line2: details.propertyAddress!.line2,
          city: details.propertyAddress!.city,
          state: (details.propertyAddress!.state
            ? { id: 0, name: 'name?', abbreviation: details.propertyAddress!.state!.abbreviation }
            : undefined) as StatesViewModel,
          zip: details.propertyAddress!.zip
        }
      : undefined) as AddressViewModel;
    let propertyType = { id: 0, value: details.propertyType };
    let propertySaleType = { id: 0, value: details.propertySaleType };
    let buyerCustomer = (details.buyer
      ? {
          id: details.buyerId,
          name: details.buyer!.name,
          emailAddress: details.buyer!.emailAddress,
          phone: details.buyer!.phone,
          phone2: details.buyer!.phone2,
          addresses:
            details.buyer!.addresses && details.buyer!.addresses[0]
              ? [
                  {
                    id: 0,
                    line1: details.buyer!.addresses[0]!.line1,
                    line2: details.buyer!.addresses[0]!.line2,
                    city: details.buyer!.addresses[0]!.city,
                    state: (details.buyer!.addresses[0]!.state
                      ? { id: 0, name: 'name?', abbreviation: details.buyer!.addresses[0]!.state!.abbreviation }
                      : undefined) as StatesViewModel,
                    zip: details.buyer!.addresses[0]!.zip
                  } as AddressViewModel
                ]
              : []
        }
      : undefined) as CustomerViewModel;
    let sellerCustomer = (details.seller
      ? {
          id: details.sellerId,
          name: details.seller!.name,
          emailAddress: details.seller!.emailAddress,
          phone: details.seller!.phone,
          phone2: details.seller!.phone2,
          addresses:
            details.seller!.addresses && details.seller!.addresses[0]
              ? [
                  {
                    id: 0,
                    line1: details.seller!.addresses[0]!.line1,
                    line2: details.seller!.addresses[0]!.line2,
                    city: details.seller!.addresses[0]!.city,
                    state: (details.seller!.addresses[0]!.state
                      ? { id: 0, name: 'name?', abbreviation: details.seller!.addresses[0]!.state!.abbreviation }
                      : undefined) as StatesViewModel,
                    zip: details.seller!.addresses[0]!.zip
                  } as AddressViewModel
                ]
              : []
        }
      : undefined) as CustomerViewModel;
    let propertyManager = (details.propertyManager
      ? {
          id: details.propertyManagerId,
          name: details.propertyManager!.name,
          emailAddress: details.propertyManager!.emailAddress,
          phone: details.propertyManager!.directPhone
          //   propMgrType: { id: details.propertyManagerTypeId, value: details.propertyManagerTypeName },
          //   propMgrStatus: { id: details.propertyManagerStatusId, value: details.propertyManagerStatusName },
        }
      : undefined) as PropertyManagerSearchViewModel;
    let initAgent = (details.initAgent
      ? {
          id: details.initAgentId,
          name: details.initAgent!.name,
          emailAddress: details.initAgent!.emailAddress,
          directPhone: details.initAgent!.directPhone,
          directFax: details.initAgent!.directFax,
          agentType: details.initAgent.agentType
            ? ({
                id: details.coopAgent && details.coopAgent!.agentType! && details.coopAgent!.agentType!.id,
                value: details.coopAgent && details.coopAgent!.agentType! && details.coopAgent!.agentType!.value
              } as OptionsViewModel)
            : null
          // agentRating: { id: 0, value: 'agentRating?' } as OptionsViewModel,
          // agentStatus: { id: 0, value: 'agentStatus?' } as OptionsViewModel,
        }
      : undefined) as RealEstateAgentViewModel;
    let initOffice = (details.initOffice
      ? {
          id: details.initOfficeId,
          name: details.initOffice!.name,
          phone: details.initOffice!.phone,
          fax: details.initOffice!.fax,
          address: (details.initOffice!.address
            ? {
                id: 0,
                line1: details.initOffice!.address!.line1,
                line2: details.initOffice
                  ? details.initOffice.address && details.initOffice.address.line2
                    ? details.initOffice.address.line2
                    : ''
                  : '',
                city: details.initOffice!.address!.city,
                state: (details.initOffice!.address!.state
                  ? { id: 0, name: 'name?', abbreviation: details.initOffice!.address!.state!.abbreviation }
                  : undefined) as StatesViewModel,
                zip: details.initOffice!.address!.zip
              }
            : undefined) as AddressViewModel
        }
      : undefined) as RealEstateOfficeViewModel;
    let coopAgent = (details.coopAgent
      ? {
          id: details.coopAgentId,
          name: details.coopAgent!.name,
          emailAddress: details.coopAgent!.emailAddress,
          directPhone: details.coopAgent!.directPhone,
          directFax: details.coopAgent!.directFax,
          agentType: {
            id: details.coopAgent && details.coopAgent!.agentType! && details.coopAgent!.agentType!.id,
            value: details.coopAgent && details.coopAgent!.agentType! && details.coopAgent!.agentType!.value
          } as OptionsViewModel
          // agentRating: { id: 0, value: 'agentRating?' } as OptionsViewModel,
          // agentStatus: { id: 0, value: 'agentStatus?' } as OptionsViewModel,
        }
      : undefined) as RealEstateAgentViewModel;
    let coopOffice = (details.coopOffice
      ? {
          id: details.coopOfficeId,
          name: details.coopOffice!.name,
          phone: details.coopOffice!.phone,
          fax: details.coopOffice!.fax,
          address: (details.coopOffice!.address
            ? {
                id: 0,
                line1: details.coopOffice!.address!.line1,
                line2: details.coopOffice
                  ? details.coopOffice && details.coopOffice.address && details.coopOffice.address.line2
                    ? details.coopOffice.address.line2
                    : ''
                  : '',
                city: details.coopOffice!.address!.city,
                state: (details.coopOffice!.address!.state
                  ? { id: 0, name: 'name?', abbreviation: details.coopOffice!.address!.state!.abbreviation }
                  : undefined) as StatesViewModel,
                zip: details.coopOffice!.address!.zip
              }
            : undefined) as AddressViewModel
        }
      : undefined) as RealEstateOfficeViewModel;
    let escrowOfficer = (details.escrowOfficer
      ? {
          id: details.escrowOfficerId,
          name: details.escrowOfficer!.name,
          emailAddress: details.escrowOfficer!.emailAddress,
          directPhone: details.escrowOfficer!.directPhone,
          directFax: details.escrowOfficer!.directFax
        }
      : undefined) as EscrowOfficerViewModel;
    let escrowOffice = (details.escrowOffice
      ? {
          id: details.escrowOffice!.id,
          phone: details.escrowOffice!.phone,
          fax: details.escrowOffice!.fax,
          address: (details.escrowOffice!.address
            ? {
                id: 0,
                line1: details.escrowOffice!.address!.line1,
                line2: details.escrowOffice!.address!.line2,
                city: details.escrowOffice!.address!.city,
                state: {
                  id: 0,
                  name: 'name?',
                  abbreviation: details.escrowOffice!.address!.state!.abbreviation
                } as StatesViewModel,
                zip: details.escrowOffice!.address!.zip
              }
            : undefined) as AddressViewModel,
          company: details.escrowOffice!.company
          // branch: 'branch?',
          // group: { id: 0, value: 'groupName?' },
          // status: { id: 0, value: 'statusName?' },
          // parentId: 0,
        }
      : undefined) as EscrowOfficeViewModel;
    let assetManager = (details.assetManager
      ? {
          id: details.assetManagerId,
          value: details.assetManager!.value
        }
      : undefined) as OptionsViewModel;
    let blankSimpleEntityVM = {
      id: 0,
      name: 'name?',
      email: 'email?',
      phone: 'phone?',
      fax: 'fax?'
    } as SimpleEntityViewModel;
    let transCoord = details.transactionCoordinator;
    let txCoords = details.additionalTxCoordinators ? details.additionalTxCoordinators : [blankSimpleEntityVM];
    let reAgents = details.additionalREAgents ? details.additionalREAgents : [blankSimpleEntityVM];
    let status = ((this.props.contractDetailsVM || {}).metadata || {}).status;
    return (
      <>
        {this.renderDialog()}
        <div className="row">
          <div className="col-xs-9">
            <div className="row">
              <div className="col-xs-9">
                <h1>Contract Information</h1>
              </div>
              <div className="col-xs-3 text-bottom">
                <CheckboxInline>
                  <input
                    onClick={() => {
                      this.setState({
                        USPSStatus: !this.state.USPSStatus
                      });
                      this.props.setUSPSStatus(
                        this.props.contractDetailsVM.id,
                        +!this.props.contractDetailsVM.mailReturned
                      );
                    }}
                    checked={this.state.USPSStatus}
                    disabled={this.props.isSavingUSPS}
                    type="checkbox"
                  />
                  <label>Mail returned?</label>
                </CheckboxInline>
              </div>
            </div>
            {status ? (
              <div className="row ml-10 pl-10">
                {status ? (
                  <>
                    <div className="col-xs-12 col-md-6">
                      <h3>
                        Status: &nbsp;{' '}
                        <strong>
                          {this.props.contractDetailsVM && this.props.contractDetailsVM!.cancelDate != null ? (
                            <strong className="red-text">{status}</strong>
                          ) : (
                            status
                          )}
                        </strong>
                      </h3>
                    </div>
                    <div className="col-xs-12 col-md-6">
                      <h3>Origin: {this.renderOrigin()}</h3>
                    </div>
                    <div className="col-xs-12 col-md-6">
                      <h3>
                        Start:{' '}
                        <strong>
                          {dateParser.parse(this.props.contractDetailsVM.termStart!).format('MM/DD/YYYY')}
                        </strong>
                        &nbsp; End:{' '}
                        <strong>{dateParser.parse(this.props.contractDetailsVM.termEnd!).format('MM/DD/YYYY')}</strong>
                      </h3>
                    </div>
                    <div className="col-xs-12 col-md-6">
                      <h3>
                        Order Date:{' '}
                        <strong>
                          {dateParser.parse(this.props.contractDetailsVM.orderDate!).format('MM/DD/YYYY')}
                        </strong>
                        &nbsp; Verified:{' '}
                        <strong>
                          {this.props.contractDetailsVM.verifiedDate
                            ? dateParser.parse(this.props.contractDetailsVM.verifiedDate!).format('MM/DD/YYYY')
                            : 'Unverified'}
                        </strong>
                      </h3>
                    </div>
                    <div className="col-xs-12 col-md-6">
                      <h3>
                        Term #: <strong>{this.props.contractDetailsVM.termNumber}</strong>
                      </h3>
                    </div>
                    <div className="col-xs-12 col-md-6">
                      <h3>
                        Creator:{' '}
                        <strong>
                          {this.props.contractDetailsVM.creator && this.props.contractDetailsVM.creator.email
                            ? this.props.contractDetailsVM.creator.email
                            : '--'}
                        </strong>
                      </h3>
                    </div>
                  </>
                ) : (
                  ''
                )}
              </div>
            ) : (
              ''
            )}
            {/* <h5>{this.props.priceAdjustmentAmount ? '$ ' + (Math.abs(+this.props.priceAdjustmentAmount)).toFixed(2) + (this.props.priceAdjustment.increase ? ' increase' : ' discount') : '$0'}</h5>*/}
            <ContractInfoComponent
              {...this.props}
              id={details.id}
              contractStatus={details.metadata ? details.metadata.status : 'No Status'}
              contactName={details.contactName}
              contactType={contactType.value}
              contactMedium={contactMedium.value}
              contactInit={contactInit.value}
              product={product}
              coverageOptions={coverageOptions}
              productGroup={productGroup}
              priceAdjustment={priceAdjustment}
              priceAdjustmentAmount={details.priceAdjustmentAmount}
              totalPrice={totalPrice}
              originalPrice={originalPrice}
              propertyAddress={propertyAddress}
              propertyType={propertyType.value}
              yearBuilt={details.yearBuilt}
              propertySaleType={propertySaleType.value}
              buyerCustomer={buyerCustomer}
              sellerCustomer={sellerCustomer}
              propertyManager={propertyManager}
              initAgent={initAgent}
              initOffice={initOffice}
              coopAgent={coopAgent}
              coopOffice={coopOffice}
              initSam={details.initSam}
              coopSam={details.coopSam}
              escrowOfficer={escrowOfficer}
              escrowOffice={escrowOffice}
              assetManager={assetManager}
              transCoordinator={transCoord}
              additionalTxCoordinators={txCoords}
              additionalREAgents={reAgents}
              totalAdjustment={details.priceAdjustmentAmount}
              contractNumber={details.contractNumber}
              noRenew={details.noRenew}
              noRenewReasons={details.noRenewReasons}
              coeDate={details.estimatedCoeDate}
              orderDate={details.orderDate}
              hasSellersCoverage={details.sellerCoverage}
            />
            <Tabs>
              <Tab title={'Service Work Order'}>
                <ServiceWorkOrderSearch contractId={this.props.match.params.id} showContractSearch={false} />
              </Tab>
              <Tab title={'Comments'}>
                <CommentSearch entityId={+this.props.match.params.id} commentType={CommentType.Contract} />
              </Tab>
              <Tab title={'Contract History'}>
                <ContractHistory contractId={this.props.match.params.id} />
              </Tab>
              <Tab title={'Related Contracts'}>
                <RelatedContracts contractId={this.props.match.params.id} />
              </Tab>
              <Tab title={'Document History'}>
                <DocumentHistoryTable entityId={+this.props.match.params.id} />
              </Tab>
            </Tabs>
          </div>
          <div className="col-xs-3">
            <h1 className="text-center">Contract Actions</h1>
            {Role.CheckRoles([Roles.Admin, ...Role.GetAllIBS()]) && (
              <div className="row center-xs">
                <button
                  className="btn btn-primary"
                  onClick={this.redirectForOrderEdit}
                  disabled={!details.metadata || !details.metadata.eligibleToEdit}
                  type="button"
                >
                  Edit Order
                </button>
              </div>
            )}
            {Role.CheckRoles([Roles.Admin, ...Role.GetAllIBS()]) && (
              <div className="row center-xs">
                <button
                  className="btn btn-primary"
                  onClick={this.redirectForMakeAPayment}
                  disabled={!details.metadata || !details.metadata.eligibleToEdit}
                  type="button"
                >
                  Make a Payment
                </button>
              </div>
            )}
            {Role.CheckRoles([Roles.Admin, Roles.IBSAdmin]) && (
              <div className="row center-xs">
                <button
                  className="btn btn-primary"
                  onClick={this.openActivateModal}
                  disabled={!details.metadata || !details.metadata.eligibleForActivation}
                  type="button"
                >
                  Activate
                </button>
              </div>
            )}
            <div className="row center-xs">
              <button
                className="btn btn-primary"
                onClick={this.redirectForCancel}
                disabled={
                  !details.metadata ||
                  !EditPermissions.CanEditField(EditableFields.CancelStatus, this.props.isOpenContract) ||
                  !(details.metadata.eligibleForCancel || details.metadata.eligibleForTermination)
                }
                type="button"
              >
                Cancel Contract
              </button>
            </div>
            {Role.CheckRoles([Roles.Admin, ...Role.GetAllIBS()]) && (
              <div className="row center-xs">
                <button
                  className="btn btn-primary"
                  onClick={this.redirectForSWOCreation}
                  disabled={!details.metadata || !details.metadata.eligibleForSWOCreation}
                  type="button"
                >
                  Create SWO
                </button>
              </div>
            )}
            {Role.CheckRoles([Roles.Admin, ...Role.GetAllIBS()]) && (
              <div className="row center-xs">
                <button
                  className="btn btn-primary"
                  disabled={
                    !details.metadata ||
                    !details.metadata.eligibleForCoEExtension ||
                    propertySaleType.value.value === 'Direct Sale'
                  }
                  onClick={this.openExtendCOEModal}
                  type="button"
                >
                  Update COE
                </button>
              </div>
            )}
            {Role.CheckRoles([Roles.Admin, Roles.IBSAdmin]) && (
              <div className="row center-xs">
                <button
                  className="btn btn-primary"
                  disabled={!details.metadata || !details.metadata.eligibleToExtendSellers}
                  onClick={this.openExtendSellersModal}
                  type="button"
                >
                  Extend Sellers
                </button>
              </div>
            )}
            {Role.CheckRoles([Roles.Admin, ...Role.GetAllIBS()]) && (
              <div className="row center-xs">
                <button
                  className="btn btn-primary"
                  type="button"
                  disabled={!details.metadata || !details.metadata.eligibleForRenew || details.noRenew.noRenewCd > 0}
                  onClick={this.openRenewalModal}
                >
                  Renew Contract
                </button>
              </div>
            )}
            {Role.CheckRoles([Roles.Admin, ...Role.GetAllIBS(), ...Role.GetAllAccounting()]) && (
              <div className="row center-xs">
                <button
                  className="btn btn-primary"
                  disabled={
                    !this.props.contractResaleModalVM || (details.metadata ? !details.metadata.eligibleForResale : true)
                  }
                  onClick={this.renderResaleModal}
                  type="button"
                >
                  Resell Contract
                </button>
              </div>
            )}
            {/* {Role.CheckRoles([Roles.Admin, ...Role.GetAllIBS()]) && (
              <div className="row center-xs">
                <button
                  className="btn btn-primary"
                  disabled={!details.metadata || !details.metadata.eligibleForResend}
                  type="button"
                >
                  Resend Contract
                </button>
              </div>
            )} */}
            {Role.CheckRoles([Roles.Admin, ...Role.GetAllIBS(), ...Role.GetAllAccounting()]) && (
              <div className="row center-xs">
                <button
                  className="btn btn-primary"
                  type="button"
                  disabled={!details.metadata || !details.metadata.eligibleForRenew || details.noRenew.noRenewCd > 0}
                  onClick={this.sendRenewalNotice}
                >
                  Send Renewal Notice
                </button>
              </div>
            )}

            {Role.CheckRoles([Roles.Admin, Roles.IBSAdmin, Roles.IBSManager, ...Role.GetAllAccounting()]) && (
              <div className="row center-xs">
                <button
                  className="btn btn-primary"
                  onClick={this.redirectForTransfer}
                  disabled={!details.metadata || !details.metadata.eligibleForTransfer}
                  type="button"
                >
                  Transfer Contract
                </button>
              </div>
            )}
            {EditPermissions.CanEditField(EditableFields.NoRenew, this.props.isOpenContract) && (
              <div className="row center-xs">
                <button
                  className="btn btn-primary"
                  onClick={this.redirectForNoRenew}
                  hidden={details.noRenew && details.noRenew!.noRenewCd > 0}
                  disabled={!details.termEnd || details.termEnd < this.currentDate || details.cancelDate !== null}
                  type="button"
                >
                  No-Renew Contract
                </button>
              </div>
            )}
            {Role.CheckRoles([Roles.Admin, ...Role.GetAllIBS(), ...Role.GetAllAccounting()]) && (
              <div className="row center-xs">
                <button
                  className="btn btn-primary"
                  onClick={this.redirectForNoRenew}
                  hidden={details.noRenew && details.noRenew!.noRenewCd < 1}
                  type="button"
                >
                  Edit/Remove No Renew Contract
                </button>
              </div>
            )}
            {Role.CheckRoles([Roles.Admin, ...Role.GetAllIBS(), ...Role.GetAllAccounting()]) && (
              <div className="row center-xs">
                <button
                  className="btn btn-primary"
                  onClick={this.suspendContract}
                  hidden={!details.metadata || !details.metadata.eligibleForSuspension}
                  type="button"
                >
                  Suspend Contract
                </button>
              </div>
            )}
            {Role.CheckRoles([Roles.Admin, ...Role.GetAllIBS(), ...Role.GetAllAccounting()]) && (
              <div className="row center-xs">
                <button
                  className="btn btn-primary"
                  onClick={this.resumeContract}
                  hidden={!details.metadata || !details.metadata.eligibleToResume}
                  type="button"
                >
                  Resume Contract
                </button>
              </div>
            )}
            {Role.CheckRoles([Roles.Admin, ...Role.GetAllIBS(), ...Role.GetAllAccounting()]) && (
              <div className="row center-xs">
                <button
                  className="btn btn-primary"
                  onClick={this.verify}
                  disabled={!details.metadata || !details.metadata.eligibleToVerify}
                  type="button"
                >
                  Verify Information
                </button>
              </div>
            )}
            {Role.CheckRoles([Roles.Admin, ...Role.GetAllIBS(), ...Role.GetAllAccounting()]) && (
              <div className="mt-50">
                <FileList
                  fileList={this.props.documents}
                  uploadCallback={this.onUploadClick}
                  removeCallback={this.onRemoveClick}
                  uploadModalTitle={'Upload Files for Contract: ' + details.contractNumber}
                  removeModalTitle={'Remove File for Contract: ' + details.contractNumber}
                  forContract={true}
                  canRemove={Role.CheckRoles([Roles.Admin, Roles.IBSAdmin, Roles.IBSManager])}
                />
              </div>
            )}
          </div>
        </div>
      </>
    );
  }
}



// WEBPACK FOOTER //
// ./src/contract/_components/contract-details/contract-details.component.tsx